import store from '@/state/store'

const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    headerRowspan: 2,
    tdAttr: () => {
      return { style: 'position: sticky;left: 0;z-index: 10;' }
    },
    thAttr: () => {
      return { style: 'position: sticky;left: 0;z-index: 10;' }
    },
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
    headerRowspan: 2,
  },
  {
    key: 'start',
    label: 'report.fields.startPoint',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'startTime',
        label: 'report.fields.startDate',
        header: 'startDate',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 0,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'startLocation',
        label: 'report.fields.startLocation',
        header: 'startAddress',
        filter: false,
        isLocked: true,
        childOfIndex: 0,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'end',
    label: 'report.fields.endPoint',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'stopTime',
        label: 'report.fields.stopDate',
        header: 'endDate',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 1,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'endLocation',
        label: 'report.fields.stopLocation',
        header: 'endAddress',
        filter: false,
        isLocked: true,
        childOfIndex: 1,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'totalTimeTrip',
    label: 'report.fields.totalTimeTrip',
    header: 'totalTimeTrip',
    filter: false,
    width: 10,
    headerRowspan: 2,
  },
  {
    key: 'tripMileage',
    label: 'report.fields.totalDistance',
    header: 'tripMileage',
    filter: false,
    width: 10,
    headerRowspan: 2,
  },
  {
    key: 'fuel',
    label: 'report.fields.fuelTitle',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'sensorType',
        label: 'report.fields.sensorType',
        header: 'sensorType',
        filter: false,
        width: 10,
        childOfIndex: 2,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'efficiency',
        label: 'report.fields.fuelEfficiency',
        header: 'efficiency',
        filter: false,
        width: 10,
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
      },
      {
        key: 'standardFuel',
        label: 'report.fields.estimatedFuel',
        header: 'standardFuel',
        filter: false,
        width: 10,
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
      },
      {
        key: 'tripFuel',
        label: 'report.fields.actualFuel',
        header: 'tripFuel',
        filter: false,
        width: 10,
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.reportVehicleTrip.isHead !== undefined)
            return item.reportVehicleTrip.isHead
              ? { rowspan: item.reportVehicleTrip.numChild }
              : { style: 'display:none' }
        },
      },
    ],
    headerColspan: 4,
  },
  {
    key: 'averageSpeed',
    label: 'report.fields.averageSpeed',
    header: 'averageSpeed',
    filter: false,
    width: 10,
    headerRowspan: 2,
  },
  {
    key: 'totalHourStop',
    label: 'report.fields.totalTimeTripStop',
    header: 'totalHourStop',
    filter: false,
    width: 10,
    headerRowspan: 2,
  },
  {
    key: 'totalIdleTime',
    label: 'report.fields.totalIdleTime',
    header: 'totalIdleTime',
    filter: false,
    width: 10,
    headerRowspan: 2,
  },
]
if (store.getters['identity/hasAccess'](['history_vehicle_geofence_column:read'])) {
  const startFieldIndex = fields.findIndex((field) => field.key === 'start')
  const endFieldsIndex = fields.findIndex((field) => field.key === 'end')
  fields[startFieldIndex].children.splice(3, 0, {
    key: 'startGeofence',
    label: 'report.fields.startGeofence',
    header: 'startGeofence',
    filter: false,
    isLocked: true,
    width: 30,
    childOfIndex: 0,
    isTopHead: 0,
  })
  fields[endFieldsIndex].children.splice(3, 0, {
    key: 'stopGeofence',
    label: 'report.fields.stopGeofence',
    header: 'stopGeofence',
    filter: false,
    isLocked: true,
    width: 30,
    childOfIndex: 1,
    isTopHead: 0,
  })
  fields[startFieldIndex].headerColspan = 3
  fields[endFieldsIndex].headerColspan = 3
}
if (store.getters['identity/hasAccess'](['vehicle_trip_odometer:read'])) {
  const endFieldsIndex = fields.findIndex((field) => field.key === 'totalTimeTrip')
  fields.splice(endFieldsIndex + 1, 0, {
    key: 'lastOdometer',
    label: 'report.fields.odometer',
    header: 'odometer',
    filter: false,
    width: 10,
    headerRowspan: 2,
  })
}

export default fields
